export default __webpack_public_path__ + "static/media/login-brand-image-4-white.1ae4acae.jpg";